// Klient-Session-Storage — bewusst getrennt vom Sachbearbeiter-Token
// (`bmd_cloud_tokens`). Der Klient hat nur einen Access-Token (kein Refresh,
// ADR-023) plus das gecachte Branding, damit wiederkehrende Besucher es ohne
// erneuten Redeem sehen.

const KLIENT_SESSION_KEY = "bmd_klient_session";

export interface KlientBranding {
  display_name: string | null;
  logo_url: string | null;
  primary_color: string | null;
  accent_color: string | null;
}

export interface KlientSession {
  access_token: string;
  branding: KlientBranding;
}

export function getKlientSession(): KlientSession | null {
  try {
    const raw = window.localStorage.getItem(KLIENT_SESSION_KEY);
    return raw ? (JSON.parse(raw) as KlientSession) : null;
  } catch {
    return null;
  }
}

export function setKlientSession(session: KlientSession | null): void {
  if (session) {
    window.localStorage.setItem(KLIENT_SESSION_KEY, JSON.stringify(session));
  } else {
    window.localStorage.removeItem(KLIENT_SESSION_KEY);
  }
}

export function clearKlientSession(): void {
  setKlientSession(null);
}
